import { Directive, ElementRef, Input, ViewContainerRef } from '@angular/core';
import { InfotextTooltipComponent } from '@/core/components/infotexttooltip/infotext-tooltip.component';

@Directive({
  selector: '[infotooltip], infotooltip'
})
export class InfoTooltipDirective {

  @Input("infotooltip") schluessel = '';

  constructor(protected element: ElementRef, protected viewContainerRef: ViewContainerRef) { }

  ngOnInit() {
    let componentRef = this.viewContainerRef.createComponent(InfotextTooltipComponent);
    componentRef.instance.InfotextKey = this.schluessel;

    const host = this.element.nativeElement;
    if(host.insertAfter !== undefined)
      host.insertAfter(componentRef.location.nativeElement, host.firstChild);
  }
}
